import { useStaticQuery, graphql } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import Highlighter from "react-highlight-words"
import cc from "classcat"
import useTranslations from "hooks/useTranslations"
import Divided from "components/organisms/common/Divided"

const InfoImage = ({ className }) => {
  const images = useStaticQuery(graphql`
    {
      harrassment: file(
        relativePath: { eq: "schools/AdobeStock_340231009.jpeg" }
      ) {
        childImageSharp {
          gatsbyImageData(quality: 90, width: 600)
        }
      }
    }
  `)

  return (
    <GatsbyImage
      image={getImage(images.harrassment)}
      imgStyle={{
        objectFit: "cover",
        objectPosition: "center",
      }}
      className={className}
      alt=""
    />
  )
}

const Text = ({ className = "", children }) => (
  <p
    className={cc([
      "m-0 whitespace-pre-line text-left font-display text-3xl text-zinc-800 sm:text-4xl",
      className,
    ])}
  >
    {children}
  </p>
)

const SmallText = ({ className = "", children }) => (
  <p
    className={cc([
      "m-0 whitespace-pre-line text-left text-lg text-zinc-800",
      className,
    ])}
  >
    {children}
  </p>
)

const Title = ({ text, highlight, highlightColor = "green" }) => {
  return (
    <Text>
      <Highlighter
        highlightClassName={cc([
          "bg-transparent",
          highlightColor === "green" && "text-kkm-green",
          highlightColor === "yellow" && "text-kkm-yellow",
        ])}
        searchWords={highlight || []}
        autoEscape
        textToHighlight={text}
        className="text-zinc-800"
      />
    </Text>
  )
}

export default () => {
  const {
    schoolsTrainingDescriptionTitle,
    schoolsTrainingInfo1Highlights,
    schoolsTrainingDescriptionText1,
    schoolsTrainingDescriptionText2,
    schoolsTrainingDescriptionText4,
    schoolsTrainingDescriptionTextBold,
  } = useTranslations()
  return (
    <Divided
      Image={InfoImage}
      title={
        <Title
          text={schoolsTrainingDescriptionTitle}
          highlight={schoolsTrainingInfo1Highlights}
          highlightColor="yellow"
        />
      }
      theme="light"
      reversed
    >
      <div className="space-y-6">
        <SmallText>{schoolsTrainingDescriptionText1}</SmallText>
        <SmallText>{schoolsTrainingDescriptionText2}</SmallText>
        <SmallText className="rounded-lg bg-kkm-yellow/70 p-3 font-black">
          {schoolsTrainingDescriptionTextBold}
        </SmallText>
        <SmallText>{schoolsTrainingDescriptionText4}</SmallText>
      </div>
    </Divided>
  )
}
